import React from 'react';
import { useSelector } from 'react-redux';
import './PromotionStripItem.css';
import { Image } from '../../../../../shared/src/components/Image';
import { PromotionCta } from '../../../../../promotions-datahub/src/components/Fold/PromotionThumbnail/PromotionCta';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';
import { ThumbnailLoading } from '../../../../../shared/src/components/ThumbnailLoading';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const PromotionStripItem = ({
    promotion,
    isLoading = false,
}) => {
    const { isLoggedIn } = useSelector((state) => state.player);
    const images = isLoading
        ? { default: '', webp: '' }
        : {
            default: promotion?.images?.thumbnail || promotion?.images?.web,
            webp: promotion?.images?.thumbnail || promotion?.images?.web,
        };
    let buttonText = isLoggedIn ? Dictionary.translate('playNow') : Dictionary.translate('open_account');
    const promotionPath = `/promotions/${promotion?.slug || ''}`;

    const titleSanitized = promotion?.content?.title
        ? StringUtilService.sanitizeHtml(promotion.content.title)
        : '';
    const subTitleSanitized = promotion?.content?.subtitle
        ? StringUtilService.sanitizeHtml(promotion.content.subtitle)
        : '';
    const ctaTextSanitized = promotion?.content?.ctaText
        ? StringUtilService.sanitizeHtml(promotion.content.ctaText)
        : buttonText;

    const ctaBackgroundColor = promotion?.colors?.ctaBackground;
    const ctaTextColor = promotion?.colors?.ctaText;
    const termsColor = promotion?.colors?.action;
    const backgroundColor = promotion?.colors?.background;

    const termsAndConditionsSanitized = promotion?.content?.terms
        ? StringUtilService.sanitizeHtml(promotion.content.terms)
        : '';

    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();

    const trackPromotionStripAction = (clickElement, clickAction) => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GRID_STRIP,
            click_element: clickElement,
            click_action: clickAction,
            grid_strip_source: 'promotions',
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
            grid_strip_type: 'promotions',
        });
    };

    const trackTermsClick = () => {
        trackPromotionStripAction(GtmEventClickElement.BUTTON, 'open terms');
    };

    const trackPromotionImageCLick = () => {
        trackPromotionStripAction(GtmEventClickElement.IMG, 'open promotion');
    };

    return (
        <div
            className="promo-strip-item"
            style={{
                '--promotions-background-color': backgroundColor || '',
                '--promotions-cta-background-color': ctaBackgroundColor || '',
                '--promotions-cta-text-color': ctaTextColor || '',
                '--cs-body-terms-color': termsColor || '',
            }}
        >
            {isLoading ? (
                <>
                    <div className="promo-strip-item__image-wrap-loader promo-strip-item__shimmer-bg">
                        <ThumbnailLoading
                            className="promo-strip-item__icon-static"
                            iconName="megaphone"
                        />
                    </div>
                    <div className="promo-strip-item__content promo-strip-item__content--loading">
                        <ThumbnailLoading
                            className="promo-strip-item__text-loader promo-strip-item__icon-static"
                            iconName="text"
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="promo-strip-item__image-wrap">
                        <a
                            href={promotionPath}
                            onClick={trackPromotionImageCLick}
                        >
                            <Image
                                images={images}
                                className="promo-strip-item__image"
                                loadingIcon={'megaphone'}
                                alt={promotion?.slug || 'promo'}
                            />
                        </a>
                    </div>
                    <div className="promo-strip-item__content">
                        {titleSanitized && (
                            <a href={promotionPath}>
                                <h4
                                    className="promo-strip-item__title"
                                    dangerouslySetInnerHTML={{ __html: titleSanitized }}
                                />
                            </a>
                        )}
                        {subTitleSanitized && (
                            <a
                                href={promotionPath}
                                className="promo-strip-item__subtitle"
                                dangerouslySetInnerHTML={{ __html: subTitleSanitized }}
                            />
                        )}
                        <div className="promo-strip-item__bottom">
                            <PromotionCta
                                ctaText={ctaTextSanitized}
                                ctaActionObj={
                                    !isLoggedIn
                                        ? promotion?.actions?.preLogin
                                        : promotion?.actions?.postLogin
                                }
                                orientation={promotion?.orientation}
                            />
                            <div className="promo-strip-item__terms"
                                onClick={trackTermsClick}
                                role="button"
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') { trackTermsClick(); }
                                }}
                            >
                                <a
                                    href={promotionPath}
                                    className="promo-strip-item__terms-text"
                                    dangerouslySetInnerHTML={{ __html: termsAndConditionsSanitized }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
